<app-page-meta pageTitle="Contact Finzy – India’s premier P2P lending solution."
               tags="peer to peer lending, investment online, contact, bangalore, india"
               description="Contact Finzy to learn about quick, low interest peer-to-peer personal loans in India. Get easy investment opportunities with fair returns. Register yourself as a P2P lender with Finzy to kick start your alternative investment.">
</app-page-meta>

<app-header></app-header>

<div class="row">
  <div class="col-xs-10 col-xs-offset-1" style="margin-top: 20px; margin-bottom: 20px;">
    <app-contact-us></app-contact-us>
  </div>
</div>

<app-footer></app-footer>